/**
 * Extrae y sanitiza el payload `cliente` que se envía a /comanda/mvp/crearComanda.
 * Centralizar aquí la lógica permite testearla sin renderizar el componente completo.
 */

export interface ClienteInput {
  docNumber?: string | null;
  name?: string | null;
  lastName?: string | null;
  email?: string | null;
  phone?: string | null;
  gender?: number | string | null;
  birth?: string | null;
  clientId?: number | null;
}

export interface DocumentoTipo {
  vtf_vch_nombre: string;
  vtf_int_idtipodocumento: number;
}

export interface ClientePayload {
  tipoDocumentoId: number;
  nroDocumento: string;
  nombre: string;
  apellido: string;
  correo: string;
  telefono: string;
  sexo: number;
  fechaNacimiento: string;
}

export function buildClientePayload(
  input: ClienteInput,
  documentList: DocumentoTipo[],
  documentType: string
): ClientePayload {
  const sexoNum =
    typeof input.gender === "number"
      ? input.gender
      : input.gender == null
      ? 0
      : Number(input.gender) || 0;

  return {
    tipoDocumentoId:
      documentList.find((doc) => doc.vtf_vch_nombre === documentType)
        ?.vtf_int_idtipodocumento ?? 2,
    nroDocumento: (input.docNumber ?? "").trim(),
    nombre: (input.name ?? "").trim(),
    apellido: (input.lastName ?? "").trim(),
    correo: (input.email ?? "").trim(),
    telefono: (input.phone ?? "").trim(),
    sexo: sexoNum,
    fechaNacimiento: input.birth ?? "",
  };
}
